import { render, staticRenderFns } from "./finance-collection.vue?vue&type=template&id=25a14e6e"
import script from "./finance-collection.vue?vue&type=script&lang=js"
export * from "./finance-collection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports